import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type Size = 'sm' | 'base' | 'md' | 'lg';
type Variant =
  | 'default'
  | 'outline'
  | 'ghost'
  | 'subtle'
  | 'outline-primary'
  | 'outline-subtle';
type Shape = 'circle' | 'rounded';


export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    size: null,
    variant: null,
    shape: null,
    disabled: { type: Boolean },
    ariaLabel: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  size?: Size;
  variant?: Variant;
  shape?: Shape;
  disabled?: boolean;
  ariaLabel: string;
};





const actualSize = computed(() => props.size ?? 'md');
const actualVariant = computed(() => props.variant ?? 'default');
const actualShape = computed(() => props.shape ?? 'circle');

const sizeClasses = computed(() => {
  const map: Record<Size, string> = {
    sm: 'w-7 h-7',
    base: 'w-8 h-8',
    md: 'w-9 h-9',
    lg: 'w-11 h-11',
  };
  return map[actualSize.value];
});

const shapeClasses = computed(() => {
  const map: Record<Shape, string> = {
    circle: 'rounded-full',
    rounded: 'rounded-lg',
  };
  return map[actualShape.value];
});

const variantClasses = computed(() => {
  const map: Record<Variant, string> = {
    default:
      'bg-white border border-solid border-fig-gray-300 text-slate-600 hover:bg-fig-gray-100',
    outline:
      'bg-transparent border border-solid border-accent text-accent hover:bg-primary-100',
    ghost: 'bg-transparent text-fig-gray-600 hover:bg-fig-gray-100',
    subtle: 'bg-btn-subtle text-slate-600 hover:bg-btn-subtle-hover',
    'outline-primary':
      'bg-white border border-solid border-primary text-primary hover:bg-btn-secondary-hover',
    'outline-subtle':
      'bg-white border border-solid border-slate-300 text-primary hover:bg-btn-secondary-hover',
  };
  return map[actualVariant.value];
});

return { __sfc: true,props, emit, actualSize, actualVariant, actualShape, sizeClasses, shapeClasses, variantClasses }
}

})